// One doc per 10-ft lane point, written to
// {ROUTE_NUMB}_{CODE}_{PATH_ID}_POINTS_{DIRECTION} by
// POST /api/projects/:id/rsa-lane-points-mongo.
//
// `mileage` exists so Embankment can run off these docs WITHOUT an FSA
// analysis in the run: it is the only field EMB reads from FSA that lane
// geometry did not already carry. It is produced by the SAME toStationAxis()
// that places <BEGIN_MILE>/<END_MILE> and the speed-segment boundaries in the
// lane XML, so it lands on the declared milepost axis (LRS-aware, and
// correctly descending for direction N) rather than a private arc-length space.
const METRES_PER_MILE = 1609.344;

export function buildLanePointDocs({
  points10ft,
  projected,
  cumulativeDistances,
  lrsPerPoint,
  lanePosition,
  direction,
  toStationAxis,
}) {
  return points10ft.map((p, i) => {
    const xyz = projected[i] || [];
    const arcMile = (cumulativeDistances[i] || 0) / METRES_PER_MILE;
    return {
      seq: i,
      lane_position: lanePosition,
      direction,
      lat: p.lat,
      lng: p.lng,
      x: Number(xyz[0]) || 0,
      y: Number(xyz[1]) || 0,
      z: Number(xyz[2]) || 0,
      distance: Math.round((cumulativeDistances[i] || 0) * 1000) / 1000,
      lrs: lrsPerPoint[i] || null,
      mileage: toStationAxis(arcMile),
    };
  });
}
